import React, { Component } from 'react';
import { connect } from 'react-redux';

import DLPReviews from './dlp-reviews';
import DLPSortDropdown from './dlp-sort-dropdown';
import SearchResults from '../../search-filter/components/search-results';
import ProductMap from '../../product/components/product-map';
import ProductCard from '../../product/components/product-card';
import { withError } from '../../shared/components/error-boundary';
import { DLP_DEFAULT_SEARCH_OPTIONS } from '..';
import { fetchPrices } from '../../product/product-actions';
import { Helpers } from '../../core/src/helpers';
import Compare from '../../compare/components/compare';
import CompareButton from '../../compare/components/compare-button';
import CompareDrawer from '../../compare/components/compare-drawer';

import '../css/dlp-product-list.less';

class DLPProductList extends Component {
    productItem = (product, key, enableAppPDP) => {
        const {
            disableCompare,
            slugKey,
            pg='test:dlp',
            toggleCompareDrag
        } = this.props;

        return (
            <ProductCard
                key={key}
                product={product}
                fetchSpecs={this.fetchTechSpecs}
                toggleCompareDrag={toggleCompareDrag}
                disableCompare={disableCompare}
                jumpInfo={{ slugKey, pg: pg.split(":").pop() }}
                enableAppPDP={enableAppPDP}
                saleCalloutPath="violatorMsg"
                hideMktDiff={true}
            />
        );
    }

    /**
     * Fetches prices for product cards that are not yet painted on the screen (all pages except first one),
     * but are available in the SearchContainer store (fetched during SSR).
     *
     * Request will get batched with other requests originating from purchase-button.jsx components
     * into a single one (see batch.jsx, services.jsx).
     *
     * However when more product cards are mounted and their product object(s) don't have associated pricing info
     * in the redux store @state.productData.productInfo.productPrice, new batch request will be formed and sent
     * to HPServices API. Later, after I improve Swiftype indexing lambda job, this should almost never happen.
     */
    fetchPrices(results, fetchPrices, pageSize) {
        if ( !(results instanceof Array) || results.length < 1)
            return;

        const ids = results
            .reduce((allResults, result) => allResults.concat(result), []) //just like flat()
            .slice(pageSize)
            .map(result => result.prodId);

        fetchPrices(ids);
    }

    componentDidMount() {
        const { results, fetchPrices } = this.props;
        const { pageSize } = DLP_DEFAULT_SEARCH_OPTIONS;
        this.fetchPrices(results, fetchPrices, pageSize);
    }

    componentDidUpdate(prevProps){
      if(prevProps.slugKey !== this.props.slugKey){
        this.fetchPrices(this.props.results, this.props.fetchPrices, DLP_DEFAULT_SEARCH_OPTIONS.pageSize);
      }
    }

    getTabs = () => [
        {
            Component: Compare,
            title: 'Compare',
            active: true,
            mobileTab: () => {
                return <CompareButton />;
            },
        },
    ];

    render() {
        const {
            results,
            isComparing,
            leftMenuActive,
            pagesRevealed,
            enableAppPDP=true,
            disableCompare
        } = this.props;

        const { pageSize } = DLP_DEFAULT_SEARCH_OPTIONS;
        const shownResults = results.slice(
            0, pagesRevealed * pageSize
        );

        const wrapperClassList = [
            "dlp-product-list",
            leftMenuActive ? "dlp-left-menu-open" : ""
        ];

        return (
            <div className={wrapperClassList.join(" ")}>
                { !disableCompare && (
                    <CompareDrawer />
                )}
                <ProductMap
                    disableMultiContainers={true}
                    products={shownResults}
                    productItem={this.productItem}
                    enableAppPDP={enableAppPDP}
                    v2={true}
                />
            </div>
        );
    }
}

const dlpProductListContainer = props => {
    return (
        <SearchResults>
            {({ results }) => (
                <React.Fragment>
                    <DLPSortDropdown match={props.match} results={results}/>
                    <DLPProductList {...props} results={results} />
                    <DLPReviews {...props} results={results}/>
                </React.Fragment>
            )}
        </SearchResults>
    );
}

export const mapStateToProps = state => ({
    leftMenuActive: state.leftMenu.active,
    isComparing: state.compare.products.length,
    prices: state.productData.productInfo.productPrices
});

export const mapDispatchToProps = dispatch => ({
    fetchPrices: Helpers.memoize(ids => dispatch(fetchPrices(ids)))
});

export default connect(mapStateToProps, mapDispatchToProps)(withError(dlpProductListContainer));
